var exports = {
  "Sl": "xaee3c4fa--5c7df3--image",
  "yK": "xaee3c4fa--5c7df3--image-success",
  "Bm": "xaee3c4fa--5c7df3--image-error",
  "o1": "xaee3c4fa--5c7df3--actions",
};

module.exports = exports;
